import coverPhoto from '../assets/hotspot/celebrationCover/Dia_de_los_Muertos.jpg';
import claudiaImage from '../assets/hotspot/headerImages/claudia-s.jpg';
import celebrationThumbnail1 from '../assets/hotspot/celebrationPerformances/gracias_a_la_vida_learning_still.jpg';
import concertThumbnail1 from '../assets/hotspot/celebrationPerformances/Claudia_concert.jpg.jpeg';

export const diaDeLosMuertos = {
  celebrationTitle: 'Día de los Muertos',
  startDate: '11-01',
  endDate: '11-01',
  filterValue: 'dia-de-los-muertos',
  displayDate: 'November 1',
  celebrationImage: coverPhoto,
  description: 'Día de los Muertos is a Mexican holiday honoring the dead, celebrated all across Latin America, the United States, and the world. On this day, people offer gifts to the dead and celebrate with their communities at lively fiestas with feasts, drinks, music, and people dressing up as death itself.',
  celebrationVideos: [
    {
      videoLink: 'https://vimeo.com/1105185529?fl=pl&fe=sh',
      videoImage: celebrationThumbnail1,
      songTitle: 'Gracias a la Vida',
      artistName: 'Claudia',
      videoTags: [
        {
          tag: 'Día de los Muertos',
        },
      ],
      songDescription: '"Gracias a la Vida" ("Thanks to Life") is an important part of Chilean culture, traditionally performed at various types of celebrations, ceremonies, and events. The song\'s role in Chilean life goes beyond entertainment—it helps bring people together to honor important moments in their communities and their roots.',
    },
    {
      videoLink: 'https://vimeo.com/1105183423?fl=pl&fe=vl',
      videoImage: concertThumbnail1,
      songTitle: 'Gracias a la Vida',
      artistName: 'Claudia',
      videoTags: [
        {
          tag: 'Día de los Muertos',
        },
      ],
    },
  ],
  artistsWhoCelebrate: [
    {
      artistName: 'Claudia',
      artistImage: claudiaImage,
    },
  ],
};
